import { useState, useEffect } from 'react';
import TrendingPage from './TrendingPage';
import IdeasPage from './IdeasPage';
import YtrendsPage from './YtrendsPage';
import MockupPage from './MockupPage';
import ShopIndexPage from './ShopIndexPage';
import TrackingPage from './TrackingPage';
import RedesignPage from './RedesignPage';
import CalendarPage from './CalendarPage';
import NichePage from './NichePage';
import LionjobExtBadge from '../components/LionjobExtBadge';
import ScrapedProductsPage from './ScrapedProductsPage';
import LionjobPage from './LionjobPage';

// 1 mục "Lionjob" duy nhất trên sidebar. Năm tab đầu là phễu chính, theo đúng thứ tự:
// Trending (phát hiện) -> Ngách (gom trend thành đề bài) -> Ideas (kiểm bản quyền)
// -> Scraped Products (kho) -> Listing Task (SEO).
// Các tab sau là công cụ hỗ trợ: Mockup, Sức khoẻ shop, Vận đơn, Redesign, Lịch mùa vụ, Ytrends.
export default function LionjobHub() {
  const [tab, setTab] = useState(() => localStorage.getItem('lionjob_tab') || 'listing');
  useEffect(() => { localStorage.setItem('lionjob_tab', tab); }, [tab]);

  return (
    <div>
      <style>{TAB_CSS}</style>
      <div className="lj-tabs">
        <button className={'lj-tab' + (tab === 'trending' ? ' active' : '')} onClick={() => setTab('trending')}>📈 Trending</button>
        <button className={'lj-tab' + (tab === 'niches' ? ' active' : '')} onClick={() => setTab('niches')}>🧭 Ngách</button>
        <button className={'lj-tab' + (tab === 'ideas' ? ' active' : '')} onClick={() => setTab('ideas')}>💡 Ideas</button>
        <button className={'lj-tab' + (tab === 'products' ? ' active' : '')} onClick={() => setTab('products')}>🌐 Scraped Products</button>
        <button className={'lj-tab' + (tab === 'listing' ? ' active' : '')} onClick={() => setTab('listing')}>🐾 Listing Task</button>
        <button className={'lj-tab' + (tab === 'mockup' ? ' active' : '')} onClick={() => setTab('mockup')}>🖼 Mockup</button>
        <button className={'lj-tab' + (tab === 'shop' ? ' active' : '')} onClick={() => setTab('shop')}>📊 Sức khoẻ shop</button>
        <button className={'lj-tab' + (tab === 'tracking' ? ' active' : '')} onClick={() => setTab('tracking')}>🚚 Vận đơn</button>
        <button className={'lj-tab' + (tab === 'redesign' ? ' active' : '')} onClick={() => setTab('redesign')}>🎨 Redesign</button>
        <button className={'lj-tab' + (tab === 'calendar' ? ' active' : '')} onClick={() => setTab('calendar')}>📅 Lịch mùa vụ</button>
        <button className={'lj-tab' + (tab === 'ytrends' ? ' active' : '')} onClick={() => setTab('ytrends')}>⚡ Ytrends</button>
      </div>
      <LionjobExtBadge />
      {tab === 'trending' && <TrendingPage />}
      {tab === 'niches' && <NichePage />}
      {tab === 'ideas' && <IdeasPage />}
      {tab === 'products' && <ScrapedProductsPage onOpenListing={() => setTab('listing')} />}
      {tab === 'listing' && <LionjobPage />}
      {tab === 'mockup' && <MockupPage />}
      {tab === 'shop' && <ShopIndexPage />}
      {tab === 'tracking' && <TrackingPage />}
      {tab === 'redesign' && <RedesignPage />}
      {tab === 'calendar' && <CalendarPage />}
      {tab === 'ytrends' && <YtrendsPage />}
    </div>
  );
}

const TAB_CSS = `
.lj-tabs{display:inline-flex;gap:0;border:1px solid var(--border);border-radius:12px;overflow:hidden;background:var(--panel);margin-bottom:16px}
.lj-tab{border:0;background:transparent;color:var(--muted);padding:8px 16px;font-size:13px;font-weight:600;cursor:pointer}
.lj-tab+.lj-tab{border-left:1px solid var(--border)}
.lj-tab:hover{color:var(--text)}
.lj-tab.active{background:var(--accent);color:#fff}
`;
